import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { useFacilityContext, virtualPageViewEvent } from '@shared-components-web';

export function VirtualPageViewTracker() {
	const router = useRouter();
	const { officeInfo } = useFacilityContext();
	const officeInfoRef = useRef(officeInfo);
	const lastFiredPathRef = useRef<string | null>(null);

	useEffect(() => {
		officeInfoRef.current = officeInfo;
	}, [officeInfo]);

	useEffect(() => {
		if (lastFiredPathRef.current === router.pathname) return;
		lastFiredPathRef.current = router.pathname;

		virtualPageViewEvent({
			brand: process.env.TAG_BRAND_THEME || 'lovet',
			websiteSelectedFacilityId: officeInfoRef.current?.code,
			websiteSelectedFacilityName: officeInfoRef.current?.name,
		});
	}, [router.pathname]);

	return null;
}
